module.exports = __webpack_public_path__ + "frontend/static/media/Women accessories.3fa8a6cd.png";